import React from 'react';
import { PageSettings } from './config/page-settings.js';
import Content from './components/content/content.jsx';
// import Footer from './components/footer/footer.jsx';
import SweetAlert from 'react-bootstrap-sweetalert';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from "react-redux";
import { updateLoginUser, resetLogin, performLogout, checkIsLoggedIn } from "./redux/AuthAction.js";
import classNames from 'classnames';
import { isObjectEmpty, stringIsNullOrEmpty, injectMetaPixel, injectExoClickGoalTag} from './util/Util.js';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import ApiEngine from './util/ApiEngine.js';
import { ApiKey, ApiUrl, SessionKey, getHostnamePixelId, hostnameExoMapping, LanguageOption } from "./util/Constant";
import { setBusy, setIdle } from "./redux/AppAction";
import { CacheKeys, getSessionCache, setSessionCache } from "./util/HomeDataCache.js";

LoadingOverlay.propTypes = undefined; 

function safeJsonParse(value) {
  if (value == null || value === '') {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);

    this.handleSetPageContent = (value) => {
      this.setState(state => ({
        pageContent: value
      }));
    }
    this.handleSetPageContentClass = (value) => {
      this.setState(state => ({
        pageContentClass: value
      }));
    }
    this.handleSetPageContentFullHeight = (value) => {
      this.setState(state => ({
        pageContentFullHeight: value
      }));
    }
    this.handleSetPageContentFullWidth = (value) => {
      this.setState(state => ({
        pageContentFullWidth: value
      }));
    }
    this.handleSetPageContentInverseMode = (value) => {
      this.setState(state => ({
        pageContentInverseMode: value
      }));
    }
    this.handleSetPageFooter = (value) => {
      this.setState(state => ({
        pageFooter: value
      }));
    }
    this.handleSetBodyWhiteBg = (value) => {
      if (value === true) {
        document.body.classList.add('bg-white');
      } else {
        document.body.classList.remove('bg-white');
      }
    }

    this.state = {
      pageContent: true,
      pageContentClass: '',
      pageContentFullHeight: false,
      pageContentFullWidth: true,
      pageContentInverseMode: false,
      handleSetPageContent: this.handleSetPageContent,
      handleSetPageContentClass: this.handleSetPageContentClass,
      handleSetPageContentFullHeight: this.handleSetPageContentFullHeight,
      handleSetPageContentFullWidth: this.handleSetPageContentFullWidth,
      handleSetPageContentInverseMode: this.handleSetPageContentInverseMode,

      pageFooter: false,
      handleSetPageFooter: this.handleSetPageFooter,
      error: null,
      errorInfo: null,

      handleSetBodyWhiteBg: this.handleSetBodyWhiteBg,
      handleSetPageBoxedLayout: this.handleSetPageBoxedLayout,

      location: window.location.href,
      language: this.props.i18n.language,
      _lastViewport: { width: 0, height: 0 },
    };
    // -----------------------------------------------------------------
    // NEW � ResizeObserver that works *inside* Chrome DevTools device mode
    this._resizeObserver = null;
    this._checkAuthInterval = null;
    this._lastSeoKey = null;
    this._seoFetchInFlight = null;
    this._handleViewportChange = (entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const w = Math.round(width);
        const h = Math.round(height);

        if (w !== this.state._lastViewport.width || h !== this.state._lastViewport.height) {
          // ----> YOUR EXISTING DESKTOP-REDIRECT LOGIC <----
          this.checkAndRedirectDesktop();

          // update state (optional � you can read it elsewhere)
          this.setState({ _lastViewport: { width: w, height: h } });
        }
      }
    };
    // -----------------------------------------------------------------
  }

  // -----------------------------------------------------------------
  // NEW � central place for the desktop-redirect (used by both resize & mount)
  checkAndRedirectDesktop = () => {
    if (typeof window === 'undefined') return;
    const isDesktop = document.documentElement.clientWidth >= 768;
    const isLocalhost = window.location.href === 'http://localhost:54006/';
    if (isDesktop && !isLocalhost) {
      let currHref = window.location.href;
      let currHostname = window.location.hostname;
      let newHref = '';
      if (currHostname.includes('-m.')) {
        newHref = currHref.replace('-m.', '.');
      } else if (currHostname.startsWith('m.')) {
        newHref = currHref.replace('m.', '');
      } else if (currHostname.includes('.huat8')) {
        newHref = currHref.replace('.huat8', '-d.huat8');
      }
      if (newHref) window.location.href = newHref;
    }
    // -----------------------------------------------------------------
  };

  async componentDidMount() {
      const savedLang = localStorage.getItem("preferredLang");
      if (savedLang) this.props.i18n.changeLanguage(savedLang);

      const tg = window.Telegram?.WebApp;
      if (tg) {
          try {
              tg.ready();
              tg.expand();

              const user = tg.initDataUnsafe?.user;
              console.log("Telegram MiniApp detected:", user);

              if (user) {
                  this.props.setBusy();
                  this.props.performLogout();
                  await fetch(`/api/telegram/miniapp-callback`, {
                      method: "POST",
                      headers: { "Content-Type": "application/json",
                                  "ngrok-skip-browser-warning": "true" },
                      body: JSON.stringify({
                          initData: tg.initData,
                          user: tg.initDataUnsafe?.user
                      }),
                  })
                  .then((res) => res.json())
                  .then((data) => {
                      if (data.success && data.data) {
                          var userData = data.data["userData"];
                          if (window.ReactNativeWebView) {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                action: "login",
                                jwtToken: data.data["jwtToken"],
                                userId: userData["userId"]
                              })
                            );
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                action: "change-theme",
                                themeId: userData["selectedTheme"],
                              })
                            );
                          }
                                
                          this.props.updateLoginUser(userData);

                          localStorage.setItem(SessionKey._ISSHOWMINIGAMETRIGGER, true);
                      }
                      this.props.setIdle();
                  })
                  .catch((err) => { this.props.setIdle(); console.error("Telegram auth error:", err) });
              }
          } catch (err) {
              console.error("Telegram Mini App init failed:", err);
          this.props.setIdle();
          }
            
      }

    this.props.checkIsLoggedIn().then(() => {
      // Once the check is completed, handle the interval logic
      this.startOrStopInterval();
    });

    const pixelId = getHostnamePixelId(window.location.hostname);
    if (pixelId) {
      injectMetaPixel(pixelId);
    }

    const exoId = hostnameExoMapping[window.location.hostname];
    if (exoId) {
      injectExoClickGoalTag(exoId);
    }

    this.scheduleSeoFetch(this.props.i18n.language);

    // ----> 1. Run once on mount (your original check)
    this.checkAndRedirectDesktop();

    // ----> 2. Initialise the ResizeObserver
    this._resizeObserver = new ResizeObserver(this._handleViewportChange);
    this._resizeObserver.observe(document.documentElement);

    // ----> 3. (Optional) Keep your old debounce-based listener as a fallback
    let lastWidth = document.documentElement.clientWidth;
    this.resizeTimeout = null;

    const handleDevToolsResize = () => {
      const cur = document.documentElement.clientWidth;
      if (Math.abs(cur - lastWidth) > 50) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.checkAndRedirectDesktop();
          lastWidth = cur;
        }, 300);
      } else {
        lastWidth = cur;
      }
    };
    window.addEventListener('resize', handleDevToolsResize);
    this._devToolsResizeHandler = handleDevToolsResize;
  };

  componentWillUnmount() {
    this.stopInterval();

    // ----> NEW � disconnect ResizeObserver
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    // ----> (fallback listener cleanup stays the same)
    if (this._devToolsResizeHandler) {
      window.removeEventListener('resize', this._devToolsResizeHandler);
      this._devToolsResizeHandler = null;
    }
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
  }

  /// <summary>
  /// Author: -
  /// </summary>
  componentDidUpdate(prevProps) {
    if (this.props.languageState.languageId != prevProps.languageState.languageId) {
      const languageOption = LanguageOption.find(
        (option) => option.languageId === this.props.languageState.languageId
      );
      if (languageOption) {
        this.props.i18n.changeLanguage(languageOption.code);
      }
    }

    const currentLanguage = this.props.i18n.language;
    const currentLocation = window.location.href;
    if (
      this.state.location !== currentLocation ||
      this.state.language !== currentLanguage
    ) {
      this.scheduleSeoFetch(currentLanguage, currentLocation);
    }

    if (this.props.authState.isLoggedIn !== prevProps.authState.isLoggedIn) {
      this.startOrStopInterval();
    }
  }

  scheduleSeoFetch(language, location = window.location.href) {
    const seoKey = `${language}|${location}`;
    if (seoKey === this._lastSeoKey || seoKey === this._seoFetchInFlight) {
      return;
    }

    this._seoFetchInFlight = seoKey;
    this.setState({
      location,
      language,
    });

    this.getSeo(language).finally(() => {
      if (this._seoFetchInFlight === seoKey) {
        this._seoFetchInFlight = null;
        this._lastSeoKey = seoKey;
      }
    });
  }

  /// <summary>
  /// Author: -
  /// </summary>
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    this.stopInterval();
  }

  startOrStopInterval() {
    if (this.props.authState.isLoggedIn) {
      this.startInterval();
    } else {
      this.stopInterval();
    }
  }

  startInterval() {
    if (this._checkAuthInterval == null) {
      this._checkAuthInterval = setInterval(() => this.props.checkIsLoggedIn(), 30000);
    }
  }

  stopInterval() {
    if (this._checkAuthInterval != null) {
      clearInterval(this._checkAuthInterval);
      this._checkAuthInterval = null;
    }
  }

  async getSeo(language) {
    try {
      const cacheKey = CacheKeys.seoScripts(language);
      let data = getSessionCache(cacheKey);

      if (!data) {
        var responseJson = await ApiEngine.get(
          `${ApiUrl._API_GET_SEO_SCRIPTS_LANGUAGE}?LanguageCode=` + language
        );

        if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
          return;
        }

        data = responseJson[ApiKey._API_DATA_KEY];
        setSessionCache(cacheKey, data);
      }

      if (!data || !Array.isArray(data)) {
        return;
      }

      var contentLength = data.length;
      var list = [];
      var newData = [];
      var newList = [];
      for (var x = 0; x < contentLength; x++) {
        var rawContent = data[x]["content"] ?? data[x]["Content"];
        var content = safeJsonParse(rawContent);
        if (!content) {
          continue;
        }

        var parameterKeys = Object.keys(content).filter((key) => key.startsWith("parameter_"));
        for (var i = 0; i < parameterKeys.length; i++) {
          var jsonObj = safeJsonParse(content[parameterKeys[i]]);
          if (!jsonObj) {
            continue;
          }
          newData.push({
            name: "PARAMETER " + (i + 1),
            metaType: jsonObj["metaType"],
            content: jsonObj["content"]
          });
        }
        newList = {
          metaType: data[x]["metaDataType"],
          data: newData
        }
        newData = [];
        list.push(newList);
      }
      var titleList = [];
      var meta = [];
      var link = [];
      var script = [];
      var noscript = [];
      var base = [];
      var title = "";

      for (var i = 0; i < list.length; i++) {
        if (list[i].metaType == 'Meta') {
          for (var x = 0; x < list[i].data.length; x++) {
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            meta.push({
              page: list[i].data[x].metaType,
              content: jsonObject
            })
          }
        } else if (list[i].metaType == 'Title') {
          for (var x = 0; x < list[i].data.length; x++) {
            titleList.push({
              page: list[i].data[x].metaType,
              content: list[i].data[x].content
            })
          }

        }
        else if (list[i].metaType == 'Link') {
          for (var x = 0; x < list[i].data.length; x++) {
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            link.push({
              page: list[i].data[x].metaType,
              content: jsonObject
            })
          }

        }
        else if (list[i].metaType == 'script') {
          for (var x = 0; x < list[i].data.length; x++) {
            var page = list[i].data[x].metaType;
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            var code = jsonObject.code.replaceAll("'", `"`);
            jsonObject.code = code;
            script.push({
              page: page,
              content: jsonObject
            });

          }

        }
        else if (list[i].metaType == 'noscript') {
          for (var x = 0; x < list[i].data.length; x++) {
            var page = list[i].data[x].metaType;
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            noscript.push({
              page: page,
              content: jsonObject
            });
          }

        }
        else if (list[i].metaType == 'Base') {
          for (var x = 0; x < list[i].data.length; x++) {
            var page = list[i].data[x].metaType;
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            base.push({
              page: page,
              content: jsonObject
            });
          }

        }
      }

      var scriptList = [];
      var metaList = [];
      var linkList = [];
      var noscriptList = [];
      var baseList = [];

      if (titleList.length > 0) {
        titleList.filter(title => (title.page == window.location.pathname)).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            title = content.content;
          }
        })

        if (stringIsNullOrEmpty(title)) {
          titleList.filter(title => (title.page == "*")).map(contentAll => {
            title = contentAll.content;
          })
        }
      }

      if (script.length > 0) {
        script.filter(scrips => ((scrips.page == window.location.pathname || scrips.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            scriptList.push(content.content);
          }
        })
      }

      if (meta.length > 0) {
        meta.filter(metas => (metas.page == "*" || metas.page == window.location.pathname)).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            metaList.push(content.content);
          }
        })
        var list = [];
        var listPage = [];
        if (metaList.length > 0) {
          var filterList = meta.filter(function (obj) {
            if (obj.content.name === "description") {
              list.push(obj.content);
              listPage.push(obj.page);
              return obj.content;
            }
          })
          var i = 0;
          var x = 0;
          while (i < metaList.length) {

            if (metaList[i] === list[x]) {
              metaList.splice(i, 1);
              x++;
            } else {
              ++i;
            }
          }
        }

        listPage.includes(window.location.pathname) ?
          filterList.filter(a => a.page == window.location.pathname).map(content => {
            metaList.push(content.content);
          })
          :
          filterList.filter(a => a.page == "*").map(content => {
            metaList.push(content.content);
          })

      }

      if (link.length > 0) {
        link.filter(links => ((links.page == window.location.pathname || links.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            linkList.push(content.content);
          }
        })
      }

      if (noscript.length > 0) {
        noscript.filter(noscripts => ((noscripts.page == window.location.pathname || noscripts.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            noscriptList.push(content.content);
          }
        })
      }

      if (base.length > 0) {
        base.filter(bases => ((bases.page == window.location.pathname || bases.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            baseList.push(content.content);
          }
        })
      }

      this.setState({
        baseList,
        noscriptList,
        scriptList,
        linkList,
        title,
        metaList,
        seo: list,
      });
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    }
  }

  render() {
    const { seo, metaList, title, linkList, scriptList, noscriptList, baseList, location, language } = this.state;

    if (this.state.errorInfo) {
      return (
        <div className="error" style={{ "padding": "20px" }}>
          <img src={"/img/error.png"} style={{ "maxWidth": "100px", "objectFit": "contain", "marginLeft": "auto", "marginRight": "auto" }} />
          <h3>Something went wrong, please contact admin for help</h3>
          <div className="m-b-30">
            {window.navigator.userAgent}
          </div>
        </div>
      );
    }
    else {
      return (
        <PageSettings.Provider value={this.state}>
          <Helmet
            title={title}
            meta={metaList}
            link={linkList}
          >
            <base href={location} />
          </Helmet>
          {scriptList &&
            scriptList.length > 0 &&
            scriptList.map(({ code, type, id, src }, index) => (
              <Helmet key={index}>
                <script key={index} src={src} id={id} type={type}>
                  {code}
                </script>
              </Helmet>
            ))
          }

          {noscriptList &&
            noscriptList.length > 0 &&
            noscriptList.map(({ code }, index) => (
              <Helmet key={index}>
                <noscript>
                  {code}
                </noscript>
              </Helmet>
            ))
          }
          {
            !window.ReactNativeWebView ?
              <LoadingOverlay
                active={this.props.appState.isBusy || !this.props.authState.loginStateInitialized}
                styles={{
                  overlay: (base) => ({
                    ...base,
                    zIndex: '10000',
                    position: 'fixed',
                  })
                }}
                className={classNames('loading-overlay')}
              >
                <p style={{ fontWeight: "700", fontSize: "20px" }}>{this.props.appState.message + '...'}</p>
              </LoadingOverlay>
              :
              <></>
          }

          {
            !isObjectEmpty(this.props.appState.alert) && <div className="sweet-alert-container"><SweetAlert {...this.props.appState.alert}>
              {!stringIsNullOrEmpty(this.props.appState.alert.content) && (this.props.appState.alert.html ? this.props.appState.alert.content : this.props.appState.alert.content.split('\n').map((item, key) => {
                return <span key={key}>{item}<br /></span>
              }))}
            </SweetAlert>
            </div>
          }
          {
            this.props.authState.loginStateInitialized &&
            <div className={classNames(
              'fade page-sidebar-fixed show page-container app-v3', {
              'page-content-full-height': this.state.pageContentFullHeight,
            })}>
              <div onClick={() => {
                if (this.state.pageSidebarToggled) {
                  this.toggleMobileSidebar();
                }
              }}>
                {this.state.pageContent && (<Content />)}
                {/* {this.state.pageFooter && (<Footer />)} */}
              </div>
            </div>
          }
        </PageSettings.Provider>
      )
    }
  }
}

const mapStateToProps = state => ({
  ...state,
});

export default
  connect(
    mapStateToProps,
    {
      updateLoginUser: updateLoginUser,
      resetLogin: resetLogin,
      performLogout: performLogout,
      checkIsLoggedIn: checkIsLoggedIn,
      setBusy: setBusy,
      setIdle: setIdle,
    }
  )(withTranslation()(App));